import React from "react"
import type { Dispatch } from "react"
import type { EmissoesParaMeuCNPJModel } from "../models/emissoesParaMeuCNPJModel"
import { EmissoesParaMeuCNPJInicial } from "../models/emissoesParaMeuCNPJModel"
import type { EmissoesParaMeuCNPJActions } from "./emissoesParaMeuCNPJActions"

type ContextType = {
    dados: EmissoesParaMeuCNPJModel
    dispatch: Dispatch<EmissoesParaMeuCNPJActions>
    erroCarregamento: string | null
    buscar: () => Promise<void>
    baixandoZip: boolean
    handleBaixarZip: () => Promise<void>
}

export const EmissoesParaMeuCNPJContext = React.createContext<ContextType>({
    dados: EmissoesParaMeuCNPJInicial,
    dispatch: () => undefined,
    erroCarregamento: null,
    buscar: async () => undefined,
    baixandoZip: false,
    handleBaixarZip: async () => undefined,
})
